import styled from "styled-components";
import { colors, values, text } from "~/assets/js/theme/constants";
import { disableMouseEvents } from "~/assets/js/theme/mixins";

export const TooltipContainer = styled.span`
    position: relative;
    display: inline-block;

    .tooltiptext {
        visibility: hidden;
        background-color: ${colors.LAYOUT.GRAY[700]};
        font-family: ${text.REGULAR.FONT};
        font-weight: ${text.REGULAR.WEIGHT};
        color: ${colors.WHITE};
        text-align: center;
        padding: 5px 12px;
        border-radius: ${values.BORDER_RADIUS}px;
        white-space: nowrap;

        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 50%;
        margin-left: -${(props) => props.textWidth / 2}px;

        opacity: 0;
        transform: translateY(10px);
        transition: ${values.DEFAULT_TRANSITION_DURATION};
        border: 1px solid ${colors.LAYOUT.GRAY[700]};
        ${disableMouseEvents}

        &::after {
            content: "";
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -7px;
            border-width: 5px;
            border-style: solid;
            border-color: ${colors.LAYOUT.GRAY[700]} transparent transparent
                transparent;
        }
    }

    &:hover {
        .tooltiptext {
            transform: translateY(2px);
            visibility: visible;
            opacity: 1;
        }
    }
`;
